import { ProviderTemplate } from '../types/communication';

/**
 * Placeholders posicionais ({{1}}, {{2}}...) de um modelo da Blip, extraídos do corpo. Quando o
 * header é um documento, "documento" entra como primeiro espaço a ligar. Derivação pura — o
 * catálogo em si vem do backend (GET /templates/provider-catalog).
 */
export const providerPlaceholders = (template: ProviderTemplate): string[] => {
    const found = new Set<string>();
    const pattern = /\{\{(\d+)\}\}/g;
    let match: RegExpExecArray | null;
    while ((match = pattern.exec(template.body)) !== null) found.add(match[1]);
    const placeholders = Array.from(found).sort((a, b) => Number(a) - Number(b));
    return template.header.type === 'DOCUMENT' ? ['documento', ...placeholders] : placeholders;
};

export const findInCatalog = (
    catalog: ProviderTemplate[],
    name: string | null | undefined,
): ProviderTemplate | undefined => catalog.find((t) => t.name === name);
